import {
  IonButton,
  IonButtons,
  IonCard,
  IonCheckbox,
  IonImg,
  IonLabel,
  IonText,
} from '@ionic/react';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import deviceImg from '@/assets/imgs/device.svg';
import emailImg from '@/assets/imgs/email.svg';
import smsImg from '@/assets/imgs/sms.svg';
import { NotificationType } from '@/interfaces/CustomerInterface/CustomerInterface';
import { ManagedModalRoutes } from '@/interfaces/ManagedModalInterface/ManagedModalInterface';
import { VersionControl } from '@/interfaces/VersionControlInterface/VersionControlInterface';
import {
  getOrderRetakeCall,
  postOrderInoiceCallNew,
  postSendNotifications,
  resumptions,
  retakes,
} from '@/redux/orderManaged/orderManagedAPI';
import {
  OrderDetailsResponseContent,
  PostOrder,
} from '@/redux/orderManaged/orderManagedInterface';
import { requestVersionControl } from '@/services/api/version';
import InsightService from '@/services/insights';
import { RootState } from '@/store';
import { getTodayDate } from '@/utils/dateHelper';
import { formatPostRetake } from '@/utils/orderHelper';

import styles from './ShippingClientManaged.module.scss';

const WEB_RESUMPTION_TYPES = ['RETAKEN', 'MANAGED', 'ASSISTED'];

interface ShippingClientManagedProps {
  nextStep: (route: ManagedModalRoutes, isEmail: boolean) => void;
  handleLoading: (e: boolean) => void;
  sendIFrameUrl: (url: string) => void;
  orderInvoiceData?: PostOrder;
}

export const ShippingClientManaged: React.FC<ShippingClientManagedProps> = ({
  handleLoading,
  sendIFrameUrl,
  nextStep,
  orderInvoiceData /*  orderIdRetake */,
}) => {
  const retakenECO = sessionStorage.getItem('retaken-eco') === 'true';
  const [optionSelected, setOptionSelected] = useState<NotificationType | null>(
    null,
  );
  const operationData = useSelector((state: any) => state.operation.data);
  const operationOrderData = useSelector(
    (state: RootState) => state.operation.order,
  );
  // retake pedido localizado por getCartId en entryManaged
  const retrievedOrderData = useSelector(
    (state: RootState) => state.orderData.data?.data,
  );
  const term = useSelector(
    (state: RootState) => state.orderData.simulationTerm,
  );
  const is_preferred = useSelector(
    (state: RootState) => state.orderData.isPreferredOffer,
  );
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [versionControl, setVersionControl] = useState<VersionControl>();
  const cartIdFound = useSelector(
    (state: RootState) => state.cartIdManaged.data.cartIdFound,
  );
  const retakeOperation = async () => {
    try {
      handleLoading(true);
      let orderRetakeDataPost;
      if (operationOrderData?.order_id) {
        if (!cartIdFound) {
          const orderRetakeData = await getOrderRetakeCall(
            operationOrderData.order_id,
          );
          orderRetakeDataPost = formatPostRetake(orderRetakeData.data);
        } else {
          orderRetakeDataPost = formatPostRetake(retrievedOrderData);
        }
        if (orderRetakeDataPost) {
          const responseRetake = await retakes(
            orderRetakeDataPost,
            operationOrderData.order_id,
          );
          if (responseRetake.data?.url_access) {
            const url = `${responseRetake.data?.url_access}&isechop=1` + '&term=3';
            sendIFrameUrl(url);
          }
        } else {
          console.error(
            'Error: no existen datos para retomar',
          );
          nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
          handleLoading(false);
        }
      } else {
        console.error('Error: no order found');
        nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
        handleLoading(false);
      }
    } catch (error: any) {
      console.error(error);
      nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
      handleLoading(false);
    }
  };
  const handleContinue = async () => {
    InsightService.logTrace('1. MANAGED - en continuar pantalla de envío');
    if (orderInvoiceData === undefined) {
      InsightService.logTrace(
        '2. MANAGED - navegar a opciones de envío - retomación',
      );
      // retomacion
      const operation = operationData?.data
        ? operationData.data
        : operationData;
      const date = getTodayDate();
      // Continuar en el dispositivo = resumption / retaken (se abre ecommerce) solo si es web, si es sms o email, con retaken se envía notificación y con resumption no hace falta
      if (
        optionSelected === NotificationType.WEB
        || optionSelected === NotificationType.SMS
        || optionSelected === NotificationType.EMAIL
      ) {
        if (retakenECO && operation.created_date === date) {
          // Mismo día = resumption
          if (operation.order.order_id) {
            fetchIframeUrl(operation.order.order_id, optionSelected);
          } else {
            fetchIframeUrl(getOrderIdUrl(), optionSelected);
          }
        } else {
          // Día diferente al actual = retaken
          retakeOperation();
        }
      } else {
        nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
        handleLoading(false);
      }
    } else {
      // no retomación
      InsightService.logTrace(
        '2. MANAGED - navegar a opciones de envío - no retomación',
      );
      if (
        optionSelected === NotificationType.EMAIL
        || optionSelected === NotificationType.SMS
      ) {
        try {
          handleLoading(true);
          // cambia el process_type a default y view mode para eco envio cliente
          // cuando es presupuesto desde app se configura a modo ASSISTED
          const orderInvoiceDataModified: PostOrder = {
            ...orderInvoiceData,
            process_type: 'DEFAULT',
            view_mode: 'DEFAULT',
            is_preferred,
            term,
          };

          const responseOrderData = await postOrderInoiceCallNew(
            orderInvoiceDataModified,
          );
          if (responseOrderData.result.http_code === 200) {
            const orderData = responseOrderData.data;
            sendNotification(optionSelected, orderData.order_id);
          }
        } catch (error) {
          handleLoading(false);
          nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
        }
      } else if (optionSelected === NotificationType.WEB) {
        try {
          handleLoading(true);
          const orderInvoiceDataModified: PostOrder = {
            ...orderInvoiceData,
            product_type: 'STD',
            term,
            is_preferred,
          };
          const response = await postOrderInoiceCallNew(
            orderInvoiceDataModified,
          );
          const responseData = response.data;
          urlIframeNoRetake(responseData);
        } catch (error) {
          InsightService.logTrace('3. MANAGED - postOrder', [{ error }]);
          handleLoading(false);
          console.error('Error:', error);
          handleLoading(false);
          nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
        }
      } else {
        nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
      }
    }
  };
  const sendNotification = async (
    option: NotificationType,
    orderId: string,
  ) => {
    try {
      await postSendNotifications(option, orderId).then(() => {
        if (optionSelected === NotificationType.EMAIL) {
          nextStep(ManagedModalRoutes.SHIPPING_FINISHED_MANAGED, true);
        } else {
          nextStep(ManagedModalRoutes.SHIPPING_FINISHED_MANAGED, false);
        }
        handleLoading(false);
      });
    } catch (error) {
      handleLoading(false);
      nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
    }
  };
  const urlIframeNoRetake = async (
    orderDetails: OrderDetailsResponseContent,
  ) => {
    try {
      if (orderDetails?.url_access) {
        const url = `${orderDetails?.url_access}&isechop=1`;
        sendIFrameUrl(url);
      } else {
        handleLoading(false);
        nextStep(ManagedModalRoutes.DENIAL, false);
      }
    } catch (error: any) {
      InsightService.logTrace('4. MANAGED - redirección', [{ error }]);
      handleLoading(false);
      nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
      console.log('Error', error);
    }
  };
  const fetchIframeUrl = async (orderId: string, option: NotificationType) => {
    try {
      handleLoading(true);
      try {
        const resumptionDetails = (await resumptions(option, orderId)).data;
        const url = `${resumptionDetails?.url_access}&isechop=1`;
        if (option === NotificationType.WEB) {
          sendIFrameUrl(url);
        } else if (
          option === NotificationType.EMAIL
          || option === NotificationType.SMS
        ) {
          if (optionSelected === NotificationType.EMAIL) {
            nextStep(ManagedModalRoutes.SHIPPING_FINISHED_MANAGED, true);
          } else {
            nextStep(ManagedModalRoutes.SHIPPING_FINISHED_MANAGED, false);
          }
          handleLoading(false);
        }
      } catch (error: any) {
        handleLoading(false);
        nextStep(ManagedModalRoutes.UNKNOWN_ERROR, false);
      }
    } catch (error: any) {
      console.log('Error', error);
      handleLoading(false);
    }
  };

  const getOrderIdUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    const orderId = searchParams.get('order_id');
    return orderId ?? '';
  };

  // - día distinto                          → retake automático
  // - mismo día + process_type "web"        → resumption web automática
  // - resto (mismo día normal y no web) → se muestran opciones de envío
  const resolvedOperation = operationData?.data
    ? operationData.data
    : operationData;
  const sliceReady = !retakenECO || Boolean(resolvedOperation?.order);
  const isSameDay = resolvedOperation?.created_date === getTodayDate();
  const autoRetake = retakenECO && sliceReady && !isSameDay;
  const autoWebResumption = retakenECO
    && sliceReady
    && isSameDay
    && WEB_RESUMPTION_TYPES.includes(resolvedOperation?.order?.process_type);
  // Solo se pinta la UI cuando los datos están listos y NO es un caso automático
  const showSelectionUI = sliceReady && !autoRetake && !autoWebResumption;
  const decisionMade = useRef(false);

  useEffect(() => {
    // nunca decidimos sin los datos del slice. Si es retomación y aún
    // no están, mantenemos el loader; el efecto se re-ejecuta al poblarse operationData.
    if (!sliceReady) {
      handleLoading(true);
      return;
    }
    if (decisionMade.current) {
      return;
    }
    decisionMade.current = true;
    if (autoRetake) {
      retakeOperation();
    } else if (autoWebResumption) {
      fetchIframeUrl(
        resolvedOperation?.order?.order_id ?? getOrderIdUrl(),
        NotificationType.WEB,
      );
    } else {
      handleLoading(false);
    }
  }, [operationData]);

  useEffect(() => {
    if (orderInvoiceData) {
      setEmail(orderInvoiceData.applicant?.email || '');
      setPhone(orderInvoiceData.applicant?.billing_address.phone || '');
    } else if (retrievedOrderData) {
      setEmail(retrievedOrderData.applicant?.email);
      setPhone(retrievedOrderData.applicant?.billing_address?.phone || '');
    } else if (operationData.data.customer) {
      setEmail(operationData.data.customer.email || '');
      setPhone(operationData.data.customer.phone || '');
    } else {
      setEmail('');
      setPhone('');
    }
  }, [retrievedOrderData, operationOrderData, orderInvoiceData]);

  useEffect(() => {
    requestVersionControl().then((res) => {
      const versionRes = res as VersionControl;
      setVersionControl(versionRes);
    });
  }, []);

  // Mientras esperamos datos del slice o en un caso automático (retake / resumption web)
  // no se pinta la UI: solo loader + redirección.
  if (!showSelectionUI) {
    return null;
  }

  return (
    <div className={styles.shippingClientManagedWrapper}>
      <div>
        <div className={styles.orderManagedTitleWrapper}>
          <IonLabel className={styles.modalOrderManagedTitle}>
            ¿Cómo quieres que enviemos el enlace para continuar la solicitud?
          </IonLabel>
        </div>
        <div className={styles.shippingClientManagedList}>
          {/* Opción Email */}
          <div
            className={classNames(styles.shippingClientManagedOption, {
              [styles.selected]: optionSelected === NotificationType.EMAIL,
            })}
            onClick={() => setOptionSelected(NotificationType.EMAIL)}
          >
            <IonCheckbox
              className={classNames({
                [styles.shippingClientManagedCheckboxChecked]:
                  optionSelected === NotificationType.EMAIL,
                [styles.shippingClientManagedCheckbox]:
                  optionSelected !== NotificationType.EMAIL,
              })}
              checked={optionSelected === NotificationType.EMAIL}
              labelPlacement="end"
            >
              <div className={styles.shippingClientManagedText}>
                <IonText className={styles.shippingClientManagedOptionName}>
                  Email
                </IonText>
                <IonText
                  className={classNames(
                    styles.shippingClientManagedCustomerData,
                    styles.emailData,
                  )}
                >
                  {email}
                </IonText>
              </div>
            </IonCheckbox>
            <IonCard className={styles.shippingClientManagedCard}>
              <IonImg
                src={emailImg}
                className={styles.shippingClientManagedImg}
              />
            </IonCard>
          </div>

          {/* Opción SMS */}
          <div
            className={classNames(styles.shippingClientManagedOption, {
              [styles.selected]: optionSelected === NotificationType.SMS,
            })}
            onClick={() => setOptionSelected(NotificationType.SMS)}
          >
            <IonCheckbox
              className={classNames({
                [styles.shippingClientManagedCheckboxChecked]:
                  optionSelected === NotificationType.SMS,
                [styles.shippingClientManagedCheckbox]:
                  optionSelected !== NotificationType.SMS,
              })}
              checked={optionSelected === NotificationType.SMS}
              labelPlacement="end"
            >
              <div className={styles.shippingClientManagedText}>
                <IonText className={styles.shippingClientManagedOptionName}>
                  Sms
                </IonText>
                <IonText
                  className={classNames(
                    styles.shippingClientManagedCustomerData,
                    styles.emailData,
                  )}
                >
                  {phone}
                </IonText>
              </div>
            </IonCheckbox>
            <IonCard className={styles.shippingClientManagedCard}>
              <IonImg
                src={smsImg}
                className={styles.shippingClientManagedImg}
              />
            </IonCard>
          </div>

          {/* Opción Web */}
          <div
            className={classNames(styles.shippingClientManagedOption, {
              [styles.selected]: optionSelected === NotificationType.WEB,
            })}
            onClick={() => setOptionSelected(NotificationType.WEB)}
          >
            <IonCheckbox
              className={classNames({
                [styles.shippingClientManagedCheckboxChecked]:
                  optionSelected === NotificationType.WEB,
                [styles.shippingClientManagedCheckbox]:
                  optionSelected !== NotificationType.WEB,
              })}
              checked={optionSelected === NotificationType.WEB}
              labelPlacement="end"
            >
              <div className={styles.shippingClientManagedText}>
                <IonText
                  className={classNames(
                    styles.shippingClientManagedCustomerData,
                    styles.emailData,
                  )}
                >
                  Continuar en este dispositivo
                </IonText>
              </div>
            </IonCheckbox>
            <IonCard className={styles.shippingClientManagedCard}>
              <IonImg
                src={deviceImg}
                className={styles.shippingClientManagedImg}
              />
            </IonCard>
          </div>
        </div>
      </div>

      <IonButtons className={styles.nextBtnWrapper}>
        <IonButton
          className="nextButton"
          onClick={() => {
            handleLoading(true);
            handleContinue();
          }}
          disabled={!optionSelected}
        >
          Continuar
        </IonButton>
      </IonButtons>
    </div>
  );
};
